module.exports = __webpack_public_path__ + "static/media/ServCo Logo for VPMA.fd66dc1d.png";